const DEDUCTION_ONLY_KEYWORDS = ["年末調整", "前月調整", "過不足", "年調"];

export const isDeductionOnlyItem = (name) => {
  if (!name) return false;
  return DEDUCTION_ONLY_KEYWORDS.some((keyword) => name.includes(keyword));
};

export const findMatchedKeyword = (name) => {
  if (!name) return null;
  return DEDUCTION_ONLY_KEYWORDS.find((keyword) => name.includes(keyword));
};

export default DEDUCTION_ONLY_KEYWORDS;
